import { Configuration, SuppliersApi } from '@/api';
import useGetSupplierQuery from '@/api/queries/useGetSupplierQuery';
import CustomToast from '@/components/CustomToast';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import NotificationForm, {
  NotificationFormData,
} from '@/modules/supplier/components/NotificationForm';
import { BellIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

const Notification = () => {
  const { currentUser } = useAuth();
  const supplierId = currentUser().supplierId;

  const {
    supplier,
    isLoading: isLoadingSupplier,
    invalidateQuery: invalidateQuerySupplier,
  } = useGetSupplierQuery(supplierId);

  const suppliersApi = new SuppliersApi(new Configuration(useAuth));

  const handleSubmitNotification = async (data: NotificationFormData) => {
    try {
      if (supplier) {
        await suppliersApi.updateSupplier(supplier.id, {
          ...supplier,
          email: data.supplier.email,
        });
      }

      toast.custom((t) => (
        <CustomToast id={t.id} message="Notification settings updated!" visible={t.visible} />
      ));

      await invalidateQuerySupplier();
    } catch (error) {
      console.error('Error while updating notification settings:', error);
    }
  };

  if (isLoadingSupplier) {
    return (
      <div className="flex justify-center py-20">
        <SpinnerIcon />
      </div>
    );
  }

  if (!supplier) {
    return;
  }

  return (
    <>
      <SettingsHeader title="Notifications" icon={<BellIcon className="w-6 h-6" />} />

      <NotificationForm onSubmit={handleSubmitNotification} supplierEmail={supplier.email} />
    </>
  );
};

export default Notification;
